module.exports = __webpack_public_path__ + "static/media/SG_Payslip_3.e21ad292.png";